export default __webpack_public_path__ + "static/media/201.062f9960.gif";